export async function uploadAssessmentLogo(
  assessmentId: string,
  file: File,
  type: "logo"
): Promise<Response> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("type", type);

  return fetch(`/api/assessments/${assessmentId}/upload`, {
    method: "POST",
    body: formData,
    credentials: "include",
  });
}

export async function uploadAssessmentDocument(
  assessmentId: string,
  file: File,
  fieldIdentifier: string
): Promise<Response> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("fieldIdentifier", fieldIdentifier);

  return fetch(`/api/assessments/${assessmentId}/documents`, {
    method: "POST",
    body: formData,
    credentials: "include",
  });
}

export async function deleteAssessmentDocument(assessmentId: string, filename: string): Promise<Response> {
  return fetch(`/api/assessments/${assessmentId}/documents/${filename}`, {
    method: "DELETE",
    credentials: "include",
  });
}

export function getAssessmentDocumentUrl(assessmentId: string, filename: string): string {
  return `/api/assessments/${assessmentId}/documents/${filename}`;
}
